const BuyStep = {
  TB_ADDON_RECOMMENDATIONS: "tbAddonRecommendationns",
  TB_DOCUMENTS: "tbDocuments",
  TB_DIRECT_DEBIT_DETAILS: "tbDirectDebitDetails",
  TB_E_PAYMENT: "tbEPayments",
  TB_GLOBAL_PAYMENTS_PAGE: "TbGlobalPaymentsPage",
};

export default BuyStep;
